import { InjectionToken } from "@angular/core";

export const BROWSER_STORAGE = new InjectionToken<Storage>("BROWSER_STORAGE");
export const APP_CONFIG_TOKEN = "APP_CONFIG"; // token per injection dei config dell'applicazione
